import type { UserInfoResponse } from '@chat-types/model/user/UserInfoResponse';
import { produce } from 'immer';
import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

interface UserListState {
  records: string;
  searchName: string;
  selectedIds: string[];
  selectedUsers: UserInfoResponse[];
}

interface UserListAction {
  setSelectedUsers: (user: UserInfoResponse[]) => void;
  setSearchName: (value: string) => void;
  resetSearchName: () => void;
  clearState: () => void;
}

const initialState: UserListState = {
  records: '20',
  searchName: '',
  selectedIds: [],
  selectedUsers: [],
};

const useUserListStore = create<UserListState & UserListAction>()(
  devtools((set) => ({
    ...initialState,
    setSelectedUsers(users: UserInfoResponse[]) {
      // MARK 기존 데이터 초기화
      set(
        produce((draft: UserListState) => {
          draft.selectedUsers = [];
          draft.selectedIds = [];
        }),
      );

      users.forEach((user) => {
        set(
          produce((draft: UserListState) => {
            draft.selectedUsers.push(user);
            draft.selectedIds.push(user.userId);
          }),
        );
      });
    },
    setSearchName(value: string) {
      set(
        produce((draft: UserListState) => {
          draft.searchName = value;
        }),
      );
    },
    resetSearchName() {
      set(
        produce((draft: UserListState) => {
          draft.searchName = '';
        }),
      );
    },
    clearState() {
      set(initialState);
    },
  })),
);

export default useUserListStore;
